var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOnedrive = function SvgOnedrive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 17.3"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "onedrive_svg__a",
    cx: -1903.9,
    cy: -89.7,
    r: 1,
    fx: -1903.9,
    fy: -89.7,
    gradientTransform: "matrix(-20.8632 24.06552 -18.38806 -14.81909 -41349.482 44487.04)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#23c0fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1c91ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "onedrive_svg__b",
    cx: -2222.8,
    cy: -27.2,
    r: 1,
    fx: -2222.8,
    fy: -27.2,
    gradientTransform: "matrix(-4.95945 -4.1635 -9.27703 11.56659 -11269.746 -8935.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#adc0ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "onedrive_svg__c",
    cx: -2184,
    cy: 37.9,
    r: 1,
    fx: -2184,
    fy: 37.9,
    gradientTransform: "matrix(-5.57176 -4.7145 7.16002 -8.46195 -12426.694 -9964.224)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#033acc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#368eff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "onedrive_svg__d",
    cx: -1784.9,
    cy: -75.8,
    r: 1,
    fx: -1784.9,
    fy: -75.8,
    gradientTransform: "rotate(66.571 -15288.62 21118.943)scale(16.015 17.2891)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3464e3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#033acc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "onedrive_svg__f",
    cx: -1683.9,
    cy: 14.4,
    r: 1,
    fx: -1683.9,
    fy: 14.4,
    gradientTransform: "matrix(9.92295 3.93527 -12.5734 16.75984 16900.307 6392.172)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "onedrive_svg__g",
    cx: -2,
    cy: 10.5,
    r: 20,
    fx: -2,
    fy: 10.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4bfde8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4bfde8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "onedrive_svg__e",
    x1: 15.7,
    x2: 15.7,
    y1: 1077.2,
    y2: 1066.7,
    gradientTransform: "translate(0 -1060.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0086ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0bf"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.4 17.3h-.6C2.9 16.8.1 13.7 0 9.9v-.4c.2-3.9 3.3-6.9 7.1-7 1.2-1.2 3.2-2.5 6-2.5s6.7 2.1 8 5.3c2.3 1 3.9 3.3 3.9 5.8s-2.8 6.3-6.3 6.3H7.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.6 4.6C5.4 6.5 3.9 9.2 3.3 10c-.7 1-2.4.6-2.2-.9-.4 3.5 2.1 6.8 5.7 7.2h.8c4.1 0 13.8-5.1 12.8-10.2-1.1-3-3.9-5.1-7.3-5.1S7.7 2.9 6.6 4.5Z",
    style: {
      fill: "url(#onedrive_svg__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6 4.6C5.4 6.5 3.9 9.2 3.3 10c-.7 1-2.4.6-2.2-.9-.4 3.5 2.1 6.8 5.7 7.2h.8c4.1 0 13.8-5.1 12.8-10.2-1.1-3-3.9-5.1-7.3-5.1S7.7 2.9 6.6 4.5Z",
    style: {
      fill: "url(#onedrive_svg__b)",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6 4.6C5.4 6.5 3.9 9.2 3.3 10c-.7 1-2.4.6-2.2-.9-.4 3.5 2.1 6.8 5.7 7.2h.8c4.1 0 13.8-5.1 12.8-10.2-1.1-3-3.9-5.1-7.3-5.1S7.7 2.9 6.6 4.5Z",
    style: {
      fill: "url(#onedrive_svg__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6 4.6C5.4 6.5 3.9 9.2 3.3 10c-.7 1-2.4.6-2.2-.9-.4 3.5 2.1 6.8 5.7 7.2h.8c4.1 0 13.8-5.1 12.8-10.2-1.1-3-3.9-5.1-7.3-5.1S7.7 2.9 6.6 4.5Z",
    style: {
      fill: "url(#onedrive_svg__d)",
      fillOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4 16.4h11.4c3 0 5.3-2.5 5.3-5.3s-2.4-5.3-5.3-5.3-4.6 2.2-5.9 4.6c-1.5 2.8-3.4 5.9-5.5 6",
    style: {
      fill: "url(#onedrive_svg__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4 16.4h11.4c3 0 5.3-2.5 5.3-5.3s-2.4-5.3-5.3-5.3-4.6 2.2-5.9 4.6c-1.5 2.8-3.4 5.9-5.5 6",
    style: {
      fillOpacity: 0.4,
      fill: "url(#onedrive_svg__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4 6.1c-1.1-3-3.9-5.1-7.2-5.1S8.8 2.2 7.6 3.5h-.1c-3.7-.1-6.3 2.8-6.5 6v.3c0 3.2 2.3 6.1 5.7 6.4h1.2c-.2 0-.4.1-.6.1h11.4c3 0 5.3-2.5 5.3-5.3s-1.5-4.3-3.6-5Z",
    style: {
      fill: "url(#onedrive_svg__g)",
      fillOpacity: 0.9
    }
  }));
};
export default SvgOnedrive;